(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("checkboxgroup", [], factory);
	else if(typeof exports === 'object')
		exports["checkboxgroup"] = factory();
	else
		root["checkboxgroup"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 